export const PARTICIPANT_HOME_PATH = "/participant";

export const PARTICIPANT_STRIPE_HOME_PATH = `${PARTICIPANT_HOME_PATH}/dashboard`;
